import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type AssetClipMatchFragment = { __typename?: 'AssetMatch', id: string, activeClipIndex?: number | null, visualMatch: { __typename?: 'VisualMatch', clips?: Array<{ __typename?: 'VisualResultMatch', startTime?: number | null, endTime?: number | null, index?: number | null } | null> | null } };

export const AssetClipMatch = /*#__PURE__*/ gql`
    fragment AssetClipMatch on AssetMatch {
  id @client
  activeClipIndex @client
  visualMatch @client {
    clips {
      startTime
      endTime
      index
    }
  }
}
    ` as unknown as DocumentNode<AssetClipMatchFragment, unknown>;

        

        
export const useAssetClipMatchFragment = (
  input: string | Omit<UseFragmentOptions<AssetClipMatchFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'AssetMatch' } };
    return input;
  })();

  return useFragment<AssetClipMatchFragment>({
    fragment: AssetClipMatch,
    fragmentName: 'AssetClipMatch',
    ...options,
  });
};
  
        